"use client";

// Libraries
import { useState, useEffect, useRef } from "react";

export default function Ellipsis(props) {
    const { children, maxLines = 3, className, disableReadMore } = props;
    const [showAll, setShowAll] = useState(false);
    const [isClamped, setIsClamped] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        const checkClamping = () => {
            if (!contentRef.current) return;

            const element = contentRef.current;
            const lineHeight = parseInt(
                window.getComputedStyle(element).lineHeight,
            );
            const maxHeight = lineHeight * maxLines;

            // Check if content is taller than allowed height
            const isTruncated = element.scrollHeight > maxHeight;
            setIsClamped(isTruncated);
        };

        checkClamping();

        // Re-check on window resize
        window.addEventListener("resize", checkClamping);
        return () => window.removeEventListener("resize", checkClamping);
    }, [children, maxLines, showAll]);

    const contentStyle = showAll
        ? {}
        : {
              display: "-webkit-box",
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
          };

    return (
        <>
            <div className={className}>
                <div ref={contentRef} style={contentStyle}>
                    {children}
                </div>
            </div>

            {isClamped && !showAll && !disableReadMore && (
                <div
                    onClick={() => setShowAll(true)}
                    className="cursor-pointer text-primary inline-flex gap-1 items-center mt-1 hover:text-primary-900"
                >
                    Voir plus
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                    </svg>
                </div>
            )}
        </>
    );
}
